<template lang="pug">
  .notification-list.js-notification-list
    .notification-list__item(
      v-for="item in notifications"
    )
      .notification(
        v-bind:class="notificationColor(item)"
      )
        .notification__icon
          img(
            v-bind:src="item.icon"
          )
        .notification__text(
          v-html="item.text"
          @click="onFilterNotification(item)"
        )
        button.notification__button-close(
          type="button"
          @click="onCloseNotification(item)"
        )
          img(src="@/assets/images/icons/grey-cross.svg")

</template>
<script>
export default {
  name: "NotificationList",
  props: ["notifications", "onCloseNotification", "onFilterNotification"],
  methods: {
    notificationColor(item) {
      return "notification_" + item.color;
    },
    notificationListFixation(notificationList) {
      if (
        window.scrollY > 105 &&
        !notificationList.classList.contains("notification-list_fixed")
      ) {
        notificationList.classList.add("notification-list_fixed");
      } else if (
        window.scrollY <= 105 &&
        notificationList.classList.contains("notification-list_fixed")
      ) {
        notificationList.classList.remove("notification-list_fixed");
      }
    }
  },
  mounted() {
    var _self = this;
    var notificationList = document.querySelector(".js-notification-list");
    document.addEventListener("scroll", function() {
      _self.notificationListFixation(notificationList);
    });
  },
  beforeDestroy() {
    var _self = this;
    var notificationList = document.querySelector(".js-notification-list");
    document.removeEventListener("scroll", function() {
      _self.notificationListFixation(notificationList);
    });
  }
};
</script>
